var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mt-5":"","mb-3":""}},[_c('h1',{staticClass:"display-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }